import {Component, Input, OnInit} from '@angular/core';
import {MatButtonToggleGroup} from "@angular/material/button-toggle";
import {isValidVariable, required} from "../../../../shared/utils";

@Component({
    selector: 'app-select-media-toggle',
    templateUrl: './select-media-toggle.component.html',
    styleUrls: ['./select-media-toggle.component.scss']
})
export class SelectMediaToggleComponent implements OnInit {

    @Input() formGroup = undefined;
    @Input() formControlName = undefined;
    @Input() mediaFilter: "image" | "document" | "video" = undefined;


    selectedMediaType: "assets" | "variable" = "assets";

    constructor() {
    }

    ngOnInit(): void {
        this.setMediaType()
    }

    public setImage(event): void {
        this.formGroup?.get(this.formControlName).setValue(event);
    }


    private setMediaType(): void {
        if (this.formGroup) {
            const control = this.formGroup.get(this.formControlName);
            if (control) {
                const val: string = control.value;
                if (val.startsWith("[[") && val.endsWith("]]")) {
                    this.selectedMediaType = "variable"
                    return
                }
            }
        }
        this.selectedMediaType = "assets"
    }


    public mediaTypeChange(event: MatButtonToggleGroup): void {
        if (this.formGroup.get(this.formControlName)) {
            this.formGroup.get(this.formControlName).setValue('');
            if (event.value === 'variable') {
                this.formGroup.get(this.formControlName).setValidators([isValidVariable(), required('Media')]);
            } else {
                this.formGroup.get(this.formControlName).setValidators([required('Media')]);
            }
        }
        this.selectedMediaType = event.value;
    }

}
